import { useQuery } from "react-query";
import { toast } from "react-toastify";
import axios from "axios";
import { branchesForCarrierWithIdQueryKey } from "./carrierQueryKeys";
import { branchUrls } from "../../URL/ApplicationUrls";
import { Branch } from "../Branch";

export const useFetchBranchesForCarrier = (carrierId: number | string | undefined) => {
  return useQuery<Branch[], Error>({
    queryKey: branchesForCarrierWithIdQueryKey(carrierId),
    queryFn: () => fetchBranches(carrierId),
    onSuccess: (branches: Branch[]) =>
      branches.map((it) => ({
        ...it,
        IsNewBranch: false,
      })),
    onError: () => {
      toast.error(
        `An error occurred when retrieving the branches of carrier with the Id ${carrierId}`
      );
    },
  });
};

const fetchBranches = async (carrierId: number | string | undefined) => {
  const { data: branches } = await axios.get<Branch[]>(
    branchUrls.branchesForCarrierWithId(carrierId)
  );
  return branches;
};
